// Vendor
import React, { lazy, Suspense } from "react";
import { Switch, Route, withRouter } from "react-router-dom";

// App
import {
  SEARCH_ROUTE,
  GOLF_CLUB_ROUTE,
  CHECKOUT_ROUTE,
  CLUB_DIR_ROUTE,
  ORDER_CONFIRMATION_ROUTE,
  TERMS_OF_SERVICE_ROUTE,
  COOKIE_POLICY_ROUTE,
  PRIVACY_POLICY_ROUTE,
  PASSWORD_RESET_ROUTE,
  VERIFY_EMAIL_ROUTE,
  START_ROUTE,
  USER_BOOKINGS_ROUTE,
  USER_NOTIFICATIONS_ROUTE,
  USER_PROFILE_ROUTE,
  ABOUT_ROUTE,
  GOLF_AREA_ROUTE
} from "common/RoutesHelper";
import Loader from "components/ui/Loader";

// Lazy loading components
const Start = lazy(() =>
  import(/* webpackChunkName: "start" */ "components/start/Start")
);
const Search = lazy(() =>
  import(
    /* webpackPrefetch: true, webpackChunkName: "search" */ "components/search/Search"
  )
);
const Club = lazy(() =>
  import(
    /* webpackPrefetch: true, webpackChunkName: "club" */ "components/club/Club"
  )
);
const Checkout = lazy(() =>
  import(/* webpackChunkName: "checkout" */ "components/checkout/Checkout")
);
const Order = lazy(() =>
  import(/* webpackChunkName: "order" */ "components/order/Order")
);
const PasswordReset = lazy(() =>
  import(
    /* webpackChunkName: "password-reset" */ "components/password-reset/PasswordReset"
  )
);
const VerifyEmail = lazy(() =>
  import(
    /* webpackChunkName: "verify-email" */ "components/verify-email/VerifyEmail"
  )
);
const UserBookings = lazy(() =>
  import(/* webpackChunkName: "user-bookings" */ "components/user/UserBookings")
);
const UserSettings = lazy(() =>
  import(/* webpackChunkName: "user-settings" */ "components/user/UserSettings")
);
const NoMatch = lazy(() =>
  import(/* webpackChunkName: "no-match" */ "components/no-match/NoMatch")
);
const ClubDir = lazy(() =>
  import(/* webpackChunkName: "club-dir" */ "components/club-directory/ClubDir")
);
const CompanyInfo = lazy(() =>
  import(/* webpackChunkName: "company-info" */ "components/info/CompanyInfo")
);

const GolfAreaFactory = lazy(() =>
  import(
    /* webpackChunkName: "golf-area" */ "components/golf-area/GolfAreaFactory"
  )
);

function Routes() {
  return (
    <Suspense fallback={<Loader fullscreen={true} />}>
      <Switch>
        <Route
          name={ABOUT_ROUTE.name}
          path={ABOUT_ROUTE.path}
          component={CompanyInfo}
        />
        <Route
          name={CHECKOUT_ROUTE.name}
          path={CHECKOUT_ROUTE.path}
          component={Checkout}
        />
        <Route
          name={COOKIE_POLICY_ROUTE.name}
          path={COOKIE_POLICY_ROUTE.path}
          component={CompanyInfo}
        />
        <Route
          name={CLUB_DIR_ROUTE.name}
          path={CLUB_DIR_ROUTE.path}
          component={ClubDir}
        />
        <Route
          name={GOLF_AREA_ROUTE.name}
          path={GOLF_AREA_ROUTE.path}
          component={GolfAreaFactory}
        />
        <Route
          name={GOLF_CLUB_ROUTE.name}
          path={GOLF_CLUB_ROUTE.path}
          component={Club}
        />
        <Route
          name={ORDER_CONFIRMATION_ROUTE.name}
          path={ORDER_CONFIRMATION_ROUTE.path}
          component={Order}
        />
        <Route
          name={PASSWORD_RESET_ROUTE.name}
          path={PASSWORD_RESET_ROUTE.path}
          component={PasswordReset}
        />
        <Route
          name={PRIVACY_POLICY_ROUTE.name}
          path={PRIVACY_POLICY_ROUTE.path}
          component={CompanyInfo}
        />
        <Route
          name={SEARCH_ROUTE.name}
          path={SEARCH_ROUTE.path}
          component={Search}
        />
        <Route
          name={START_ROUTE.name}
          path={START_ROUTE.path}
          exact
          component={Start}
        />
        <Route
          name={TERMS_OF_SERVICE_ROUTE.name}
          path={TERMS_OF_SERVICE_ROUTE.path}
          component={CompanyInfo}
        />
        <Route
          name={USER_BOOKINGS_ROUTE.name}
          path={USER_BOOKINGS_ROUTE.path}
          component={UserBookings}
        />
        <Route
          name={USER_PROFILE_ROUTE.name}
          path={USER_PROFILE_ROUTE.path}
          component={UserSettings}
        />
        <Route
          name={USER_NOTIFICATIONS_ROUTE.name}
          path={USER_NOTIFICATIONS_ROUTE.path}
          component={UserSettings}
        />
        <Route
          name={VERIFY_EMAIL_ROUTE.name}
          path={VERIFY_EMAIL_ROUTE.path}
          component={VerifyEmail}
        />
        <Route name="no-match" component={NoMatch} />
      </Switch>
    </Suspense>
  );
}

export default withRouter(Routes);
